/* global require*/

angular.module('app.service', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging', 'uiGmapgoogle-maps'])
    .config(['$routeProvider', function routerProvider($routeProvider) {
      $routeProvider.when('/service/info', {
        template: require('./info.html'),
        controller: 'serviceInfoCtrl',
      });
    }])
    .controller('serviceInfoCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $window, AuthService, envService, uiGmapGoogleMapApi, Upload) => {
      $rootScope.mainmenu = 'service';
      $rootScope.menu = 'info';
      const APIURL = envService.read('apiUrl');
      if (!AuthService.isAuthenticated()) {
        $location.path('/login');
        return;
      }

      $resource(`${APIURL}/admin/service/info`).get((data) => {
        console.log(data);
        $scope.infos = data.infos;
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });

      $scope.remove = (targetInfo) => {
        $scope.infos = $scope.infos.filter(info => info != targetInfo); // eslint-disable-line eqeqeq
      };

      $scope.add = () => {
        $scope.infos.push({ URL: '', DESCRIPTION: '' });
      };

      $scope.save = () => {
        const infos = $scope.infos.filter(info => info.URL.length > 0);
        $resource(`${APIURL}/admin/service/info`).save({ INFOS: infos }, (data) => {
          console.log(data);
          $scope.infos = data.infos;
          alert($translate.instant('저장되었습니다.'));
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };

      $scope.upload = (info, files) => {
        if (files && files.length) {
          const file = files[0];
          Upload.upload({
            url: `${APIURL}/admin/file/info`,
            file,
          }).progress(() => {
          }).success((data, status, headers, config) => {
            console.log(`file ${config.file.name}uploaded. Response: ${data}`);
            console.log(data);
            info.URL = data.url;
          });
        }
      };
    });



// WEBPACK FOOTER //
// ./src/app/service/service.js